import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './orderActionTypes';
import * as actions from './orderActions';
import * as endpoints from '../../services/endpoints';
import * as alert from '../alert/alertActions';

function* getOrderSaga(action) {
  try {
    const { data } = yield call(endpoints.getOrder, action.payload);
    console.log('data')
    console.log('data')
    console.log(data)
    yield put(actions.getOrderSuccess(data));
  } catch (e) {
    yield put(actions.getOrderError(e));
  }
}

function* addOrderSaga(action) {
  try {
    const { data } = yield call(endpoints.addOrder, action.payload);
    yield put(actions.addOrderSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Sipariş başarıyla oluşturuldu',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/orders');
        }, 1500);
      }
    }
  } catch (e) {
    yield put(actions.addOrderError(e));
  }
}

function* updateOrderSaga(action) {
  try {
    const { data } = yield call(endpoints.updateOrder, action.payload);
    yield put(actions.updateOrderSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Sipariş başarıyla güncellendi',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/orders');
        }, 1000);
      }
    }
  } catch (e) {
    yield put(actions.updateOrderError(e));
  }
}

function* deleteOrderSaga(action) {
  try {
    const { data } = yield call(endpoints.deleteOrder, action.payload);
    yield put(actions.deleteOrderSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Sipariş başarıyla silindi',
        variant: 'success',
      }));
      yield put(actions.getOrderRequest({}));
    }
  } catch (e) {
    yield put(actions.deleteOrderError(e));
  }
}

function* getOrderDetailsSaga(action) {
  try {
    const { data } = yield call(endpoints.getOrderDetails, action.payload);
    console.log('data')
    console.log(data)
    yield put(actions.getOrderDetailsSuccess(data));
  } catch (e) {
    yield put(actions.getOrderDetailsError(e));
  }
}

function* orderActionSaga(action) {
  try {
    console.log('action')
    console.log(action.payload)
    const { data } = yield call(endpoints.orderAction, action.payload);
    console.log('data')
    console.log(data)
    yield put(actions.orderActionSuccess(data));
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Sipariş işlemi başarıyla gerçekleştirildi',
        variant: 'success',
      }));
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/orders');
        }, 1500);
      }
    } else {
      // API'den hata döndüğünde
      yield put(alert.setAlertAction({
        title: 'Hata!',
        text: data.Result?.ErrorDescription || 'Sipariş işlemi sırasında bir hata oluştu',
        variant: 'danger',
      }));
    }
  } catch (e) {
    // Network veya diğer hatalar için
    yield put(actions.orderActionError(e));
    
    // Daha detaylı hata mesajı
    let errorMessage = 'Sipariş işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.';
    if (e.response?.data?.Result?.ErrorDescription) {
      errorMessage = e.response.data.Result.ErrorDescription;
    } else if (e.response?.data?.message) {
      errorMessage = e.response.data.message;
    } else if (e.message) {
      errorMessage = e.message;
    }
    
    yield put(alert.setAlertAction({
      title: 'Hata!',
      text: errorMessage,
      variant: 'danger',
    }));
  }
}

function* updateSwapStockSaga(action) {
  try {
    const { data } = yield call(endpoints.updateSwapStock, action.payload);
    yield put(actions.updateSwapStockSuccess(data));

    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Stoktan sevkiyata aktarım başarılı',
        variant: 'success',
      }));

      if (action.payload?.OrderGuid) {
        yield put(actions.getOrderDetailsRequest({
          SessionUserId: action.payload.SessionUserId,
          OrderGuid: action.payload.OrderGuid,
        }));
      }
    } else {
      yield put(alert.setAlertAction({
        title: 'Hata!',
        text: data.Result?.ErrorDescription || 'Stok aktarımı sırasında bir hata oluştu',
        variant: 'danger',
      }));
    }
  } catch (e) {
    yield put(actions.updateSwapStockError(e));

    const errorMessage =
      e.response?.data?.Result?.ErrorDescription ||
      e.response?.data?.message ||
      e.message ||
      'Stok aktarımı sırasında bir hata oluştu';

    yield put(alert.setAlertAction({
      title: 'Hata!',
      text: errorMessage,
      variant: 'danger',
    }));
  }
}

function* updateSwapShipmentSaga(action) {
  try {
    const { data } = yield call(endpoints.updateSwapShipment, action.payload);
    yield put(actions.updateSwapShipmentSuccess(data));

    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(alert.setAlertAction({
        title: 'Başarılı!',
        text: 'Sevkiyattan stoğa aktarım başarılı',
        variant: 'success',
      }));

      if (action.payload?.OrderGuid) {
        yield put(actions.getOrderDetailsRequest({
          SessionUserId: action.payload.SessionUserId,
          OrderGuid: action.payload.OrderGuid,
        }));
      }
    } else {
      yield put(alert.setAlertAction({
        title: 'Hata!',
        text: data.Result?.ErrorDescription || 'Sevkiyat aktarımı sırasında bir hata oluştu',
        variant: 'danger',
      }));
    }
  } catch (e) {
    yield put(actions.updateSwapShipmentError(e));

    const errorMessage =
      e.response?.data?.Result?.ErrorDescription ||
      e.response?.data?.message ||
      e.message ||
      'Sevkiyat aktarımı sırasında bir hata oluştu';

    yield put(alert.setAlertAction({
      title: 'Hata!',
      text: errorMessage,
      variant: 'danger',
    }));
  }
}

function* watchGetOrder() {
  yield takeEvery(types.GET_ORDER_REQUEST, getOrderSaga);
}
function* watchAddOrder() {
  yield takeEvery(types.ADD_ORDER_REQUEST, addOrderSaga);
}
function* watchUpdateOrder() {
  yield takeEvery(types.UPDATE_ORDER_REQUEST, updateOrderSaga);
}
function* watchDeleteOrder() {
  yield takeEvery(types.DELETE_ORDER_REQUEST, deleteOrderSaga);
}

function* watchGetOrderDetails() {
  yield takeEvery(types.GET_ORDER_DETAILS_REQUEST, getOrderDetailsSaga);
}

function* watchOrderAction() {
  yield takeEvery(types.ORDER_ACTION_REQUEST, orderActionSaga);
}

function* watchUpdateSwapStock() {
  yield takeEvery(types.UPDATE_SWAP_STOCK_REQUEST, updateSwapStockSaga);
}

function* watchUpdateSwapShipment() {
  yield takeEvery(types.UPDATE_SWAP_SHIPMENT_REQUEST, updateSwapShipmentSaga);
}

export function* orderSaga() {
  yield all([
    watchGetOrder(),
    watchAddOrder(),
    watchUpdateOrder(),
    watchDeleteOrder(),
    watchGetOrderDetails(),
    watchOrderAction(),
    watchUpdateSwapStock(),
    watchUpdateSwapShipment(),
  ]);
} 